/* global axios */
import ApiClient from './ApiClient';

class WiseSessionAPI extends ApiClient {
  constructor() {
    super('wise/session', { accountScoped: true });
  }

  companies() {
    return axios.get(this.url);
  }

  launch(companyId, wiseUserId) {
    const payload = {};
    if (companyId) payload.company_id = companyId;
    if (wiseUserId) payload.wise_user_id = wiseUserId;
    return axios.post(this.url, payload);
  }
}

export default new WiseSessionAPI();
